export function createThemeBackground(game, slotKey) {
    const sprite = game?.theme?.createSprite(slotKey, game.width, game.height, {
        fitMode: 'cover',
    });
    if (!sprite) return null;

    sprite.x = game.width / 2;
    sprite.y = game.height / 2;
    sprite.alpha = 0.42;
    return sprite;
}
